import Head from 'next/head';

// One <meta property="og:locale:alternate"> per language the page exists in.
// next-seo keeps only one tag per property, so these go through next/head.
export function OgLocaleAlternates({ locales = [] }) {
  return (
    <Head>
      {locales.map((locale) => (
        <meta
          key={`og-locale-alternate-${locale}`}
          property="og:locale:alternate"
          content={locale}
        />
      ))}
    </Head>
  );
}
